import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-726777bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TESLA", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "LABZ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import getImage from '@/tools/getImage';
    import {computed, reactive} from 'vue';
    
    interface IProps {
        imageStyle: string,
        textStyle: number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoModule',
  props: {
    imageStyle: {},
    textStyle: {}
  },
  setup(__props: any) {

const props = __props;

    

    let imageStyle = computed(() => {
        return `height: ${props.imageStyle}%; max-width: ${props.imageStyle}%;  min-width: 3em;`
    })

    let textStyle = computed(() => {
        return `font-size: ${props.textStyle}em;`
    })


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: {name: 'home'},
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", {
        style: _normalizeStyle(_unref(imageStyle))
      }, [
        _createElementVNode("img", {
          src: _unref(getImage)('logo.webp'),
          alt: "logo image"
        }, null, 8, _hoisted_1)
      ], 4),
      _createElementVNode("div", {
        style: _normalizeStyle(_unref(textStyle)),
        class: "logo-text"
      }, _hoisted_4, 4)
    ]),
    _: 1
  }))
}
}

})